import React from 'react';
import {
  FaArrowRight,
  FaCalendarAlt,
  FaEnvelope,
  FaFacebookF,
  FaInstagram,
  FaPhoneAlt,
  FaTwitter,
  FaYoutube,
} from 'react-icons/fa';
import { Link } from 'react-router-dom';

const FooterOne = () => {
  return (
    <>
      {/* ================== Footer One Start ==================*/}
      <footer className="footer-area bg-black bg-cover">
        {/**---<div className="footer-subscribe">
          <div className="container">
            <div
              className="footer-subscribe-inner bg-cover"
              style={{ backgroundImage: 'url("./assets/img/bg/6.png")' }}
            >
              <div className="row">
                <div className="col-lg-6">
                  <h2 className="mb-lg-0 mb-3">Subscribe To Our Newsletter</h2>
                </div>
                <div className="col-lg-6 align-self-center text-lg-end">
                  <input type="text" placeholder="Your e-mail address" />
                  <Link className="btn btn-black border-radius-0" to="#">
                    Submit now
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>--- */}
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-6">
              <div className="widget widget_about">
                <div className="thumb">
                  <img src="assets/img/footer-logo.png" alt="img" />
                </div>
                <div className="details">
                  <p>
                  #6, 14th Main Road, Galeyara Balaga (A. G. B. J. B. Kaval), Mahalaxmipuram,<br/> Bangalore - 560086
                  </p>
                 {/**--- <p className="mt-3">
                    <FaPhoneAlt /> 97386 23496
                  </p>
                  <p className="mt-2" style={{fontSize:'14px',}}>
                    <FaEnvelope /> info@bhavanyatravelmart.com
                  </p>
                  <ul className="social-media">
                    <li>
                      <Link to="#">
                        <FaFacebookF />
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <FaTwitter />
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <FaInstagram />
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <FaYoutube />
                      </Link>
                    </li>
                  </ul>--- */}
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="widget widget_nav_menu">
                <h4 className="widget-title">Our Service</h4>
                <ul>
                  <li>
                    <Link to="/AirTicketing">
                      <FaArrowRight /> Air Ticketing 
                    </Link>
                  </li>
                  <li>
                    <Link to="/TravelInsurance">
                      <FaArrowRight /> Travel Insurance
                    </Link>
                  </li>
                  <li>
                    <Link to="/DomesticInternationalTours">
                      <FaArrowRight /> Domestic and international Tour 
                    </Link>
                  </li>
                  <li>
                    <Link to="/MICE">
                      <FaArrowRight /> MICE
                    </Link>
                  </li>
                  <li>
                    <Link to="/PassportVisa">
                      <FaArrowRight /> Passport & Visa Assistance
                    </Link>
                  </li>
                  <li>
                    <Link to="/HotelBooking">
                      <FaArrowRight /> Hotel Booking
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="widget widget_nav_menu">
                <h4 className="widget-title">Quick links</h4>
                <ul>
                  <li>
                    <Link to="/#">
                      <FaArrowRight /> Home
                    </Link>
                  </li>
                  <li>
                    <Link to="/AboutCompany">
                      <FaArrowRight /> About Us
                    </Link>
                  </li>
                  <li>
                    <Link to="/contact">
                      <FaArrowRight /> Contact Us{' '}
                    </Link>
                  </li>
                  <li>
                    <Link to="/TermsCondition">
                      <FaArrowRight /> Terms and Conditions
                    </Link>
                  </li>
                  <li>
                    <Link to="/PrivacyPolicy">
                      <FaArrowRight /> Privacy Policy
                    </Link>
                  </li>
                  <li>
                    <Link to="/#">
                      <FaArrowRight /> Blog
                    </Link>
                  </li>
                  
                </ul>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="widget widget_about">
              <h4 className="widget-title">Contact Details</h4>
                <div className="details">
                 
                  <p className="mt-3">
                    <FaPhoneAlt /> 63631 69466
                  </p>
                  <p className="mt-2" style={{fontSize:'14px',}}>
                    <FaEnvelope /> info@bhavanyatravelmart.com
                  </p>
                  <ul className="social-media">
                    <li>
                      <Link to="#">
                        <FaFacebookF />
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <FaTwitter />
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <FaInstagram />
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <FaYoutube />
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="container">
            <div className="row">
              <div className="col-md-12 align-self-center">
                <p>© Bhavanya Travel Mart Pvt Ltd  2025 | All Rights Reserved | Designed &amp; Hosted By <Link to="https://webuniversals.co.in/">Web Universals</Link></p>
              </div>
              {/**---<div className="col-md-6 text-lg-end">
                <Link to="#"></Link>
                <Link to="#"></Link>
              </div>--- */}
            </div>
          </div>
        </div>

        <div className="call-us">

		<Link className="call-to-action-button" to="tel:6363169466" title="">Call Us : 63631 69466</Link>

	</div>
      </footer>
      {/* ================== Footer One  end ==================*/}
    </>
  );
};

export default FooterOne;
